
import {store} from '@/store';
import { AppModule } from '@/store/modules/app';
import { ThemeConfModule } from '@/store/modules/theme';


import { getModule } from 'vuex-module-decorators';
import { formatPercent } from '@/author/components/helper/i18n';
const AppState = getModule(AppModule, store);
const ThemeConf = getModule(ThemeConfModule, store);

export const getSessionInfo = () => ({
  passingScorePercentage: formatPercent(sessionPassingScore()),
  isTestout: isTestout()
});

function sessionPassingScore() {
  return isTestoutSessionActive() ? ThemeConf.testoutPassingScore : ThemeConf.passingScore;
}
function isTestout(): boolean {
  return AppState.getIsTestout;
}

function isTestoutSessionActive(): boolean {
  return isTestout() && !AppState.failedTestout;
}